module.exports = __webpack_public_path__ + "img/color.364b555.webp";